import { Component, ViewChild } from '@angular/core';
import { DataTableDirective, DataTablesModule } from 'angular-datatables';
import { Subject } from 'rxjs';
import { LetterDocumentService } from '../../../Model/LetterDocument/letter-document.service';
import { ToastService } from '../../../Util/Toast/toast.service';
import { SessionService } from '../../../Util/Session/session.service';
import { CommonModule } from '@angular/common';
import { LoaderComponent } from '../../../Component/Loader/loader/loader.component';
import { CommonService } from '../../../Model/Common/common.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ApproveRejectDialogComponent } from '../../../Component/ApproveRejectDialog/approve-reject-dialog/approve-reject-dialog.component';
import { AlertSuccessComponent } from '../../../Component/Alert/alert-success/alert-success.component';
import { AlertWarningComponent } from '../../../Component/Alert/alert-warning/alert-warning.component';
import { ConfirmationComponent } from '../../../Component/Confirmation/confirmation/confirmation.component';
import { HttpClient } from '@angular/common/http';
import { IfreamDialogComponent } from '../../../Component/ifream-dialog/ifream-dialog.component';

@Component({
  selector: 'app-employee-letter',
  standalone: true,
  imports: [CommonModule, LoaderComponent, DataTablesModule],
  templateUrl: './employee-letter.component.html',
  styleUrl: './employee-letter.component.scss'
})
export class EmployeeLetterComponent {
  isDisabled: boolean = false;
  user = [] as any;
  TableDatas: any[] = [];
  dtTrigger: Subject<any> = new Subject<any>();
  @ViewChild(DataTableDirective, { static: false }) dtElement!: DataTableDirective;
  dtoptions: DataTables.Settings = {};
  constructor(
    private toast: ToastService,
    private letterDocument: LetterDocumentService,
    private session: SessionService,
    protected common: CommonService,
    private modalService: NgbModal,
    private http: HttpClient
  ) {
    this.user = this.session.GetUserDetails();
    this.dtoptions = { ...this.common.commonDToptions };
  }

  ngOnInit(): void {
    this.ESS_EmployeeLetterDetailsLoad();
  }

  ngAfterViewInit(): void {
    this.dtTrigger.next(null);
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  ESS_EmployeeLetterDetailsLoad() {
    this.isDisabled = true;
    this.letterDocument.ESS_EmployeeLetterDetailsLoad({ SelectType: 'GetAllLetters', EmpMasterID: this.user.UserId }).subscribe({
      next: (response) => {
        if (response.Table) {
          this.TableDatas = Object.values(response.Table);
        } else {
          this.TableDatas = Object.values([]);
        }
        this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
          dtInstance.destroy();
          this.dtTrigger.next(null);
        });
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  ARAction(index: number) {
    const modalRef = this.modalService.open(ApproveRejectDialogComponent);
    modalRef.componentInstance.Detail.ID = this.TableDatas[index]['ESS_LetterTemplateGeneration_EmployeeID'];
    modalRef.componentInstance.Header = 'Acknowledge';
    modalRef.componentInstance.PostiveButton = 'Accept';
    modalRef.componentInstance.showReInitiat = false;
    modalRef.result.then(result => {
      if (result != undefined) {
        if (this.common.ToLowerCase(result.Flag) == 'approve') {
          result.Flag = 'APPROVED'
        } else if (this.common.ToLowerCase(result.Flag) == 'reject') {
          result.Flag = 'REJECTED'
        }
        this.ESS_LetterEmployeeAcknowledgement(result, index);
      }
    });
  }

  ESS_LetterEmployeeAcknowledgement(detail: any, index: number) {
    this.isDisabled = true;
    this.letterDocument.ESS_LetterEmployeeAcknowledgement({ SelectType: 'Response', ESS_LetterTemplateGeneration_EmployeeId: this.TableDatas[index]['ESS_LetterTemplateGeneration_EmployeeID'], ApprovalStatus: detail.Flag, Remark: detail.Remark, EmpMasterID: this.TableDatas[index]['EmpMasterID'] }).subscribe({
      next: (response) => {
        if (response.Error_Code == '546' || response.Error_Code == '554') {
          const modalRef = this.modalService.open(AlertSuccessComponent, {
            size: 'md',
            backdrop: 'static',
            centered: true,
            windowClass: 'confirmation-modal'
          });
          modalRef.componentInstance.Message = response.Error_Message;
          modalRef.result.then((result: any) => {
            if (result) {
              this.ESS_EmployeeLetterDetailsLoad();
            }
          });
        }
        else {
          const modalRef = this.modalService.open(AlertWarningComponent, {
            size: 'md',
            backdrop: 'static',
            centered: true,
            windowClass: 'confirmation-modal'
          });
          modalRef.componentInstance.Message = response.Error_Message;
          modalRef.result.then((result: any) => { });
        }
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  Esign(index: number) {
    const modalRef = this.modalService.open(ConfirmationComponent, {
      size: 'md',
      backdrop: 'static',
      centered: true,
      windowClass: 'confirmation-modal'
    });
    modalRef.componentInstance.Message = 'Do you want to esign?';
    modalRef.result.then((result: any) => {
      if (result) {
        const modalRef2 = this.modalService.open(IfreamDialogComponent, {
          size: 'xl',
          backdrop: 'static',
          centered: true,
          windowClass: 'confirmation-modal'
        });
        modalRef2.componentInstance.email = this.TableDatas[index].EmailId;
        modalRef2.componentInstance.city = this.TableDatas[index].CityName;
        modalRef2.componentInstance.data = this.TableDatas[index];

        modalRef2.result.then((result: any) => {
          if (result) {
            if (result.result) {
              if (result.GroupID != null && result.GroupID != "") {
                this.letterDocument.fetchingTransectionDetailsWithgroupId({ groupId: result.GroupID, LetterGenerationFileName: this.TableDatas[index].LetterGenerationFileName, ESS_LetterTemplateGenerationRequestID: this.TableDatas[index].ESS_LetterTemplateGenerationRequestID }).subscribe({
                  next: (response) => {
                    if (response.finalDocumentUrl != null && response.finalDocumentUrl != '') {
                      this.TableDatas[index].LetterGenerationFileName = response.finalDocumentUrl;
                      this.TableDatas[index].IsESignInDone = response.IsESignInDone;
                    } else {
                      const modalRef3 = this.modalService.open(AlertWarningComponent, {
                        size: 'md',
                        backdrop: 'static',
                        centered: true,
                        windowClass: 'confirmation-modal'
                      });
                      modalRef3.componentInstance.Message = response.Error_Message;
                      modalRef3.result.then((result: any) => { });
                    }
                    this.isDisabled = false;
                  },
                  complete: () => { },
                  error: (error) => {
                    this.isDisabled = false;
                  },
                });
              }
            }
          }
        });

        // this.isDisabled = true;
        // this.http.get(this.TableDatas[index].LetterGenerationFileName, { responseType: 'blob' }).subscribe((blob) => {
        //   const reader = new FileReader();
        //   reader.onloadend = () => {
        //     this.letterDocument.ZoopEsignProcess({
        //       documentName: this.TableDatas[index].LetterName,
        //       base64Document: reader.result?.toString().replace("data:application/pdf;base64,", ""),
        //       documentInfo: 'Letter',
        //       //signers: [{ signer_name: this.user.UserName, signer_email: 'matin.mansuri@maxus.co.in', signer_city: 'surat', signer_purpose: 'Letter Acknowlegment', sign_coordinates: [{ page_num: this.TableDatas[index].AddESignInOn == 'firstpageonly'?1:this.TableDatas[index].AddESignInOn == 'lastpageonly'?10:0, x_coord: this.TableDatas[index].Xcoordinate, y_coord: this.TableDatas[index].Ycoordinate }] }],
        //       signers: [{ signer_name: this.user.UserName, signer_email: 'matin.mansuri@maxus.co.in', signer_city: 'surat', signer_purpose: 'Acknowledged', sign_coordinates: [{ page_num: 0, x_coord: this.TableDatas[index].Xcoordinate, y_coord: this.TableDatas[index].Ycoordinate }] }],
        //     }).subscribe({
        //       next: (response) => {
        //         if (response.signUrl != null && response.signUrl != '' && response.groupId != null && response.groupId != '') {
        //           const modalRef2 = this.modalService.open(IfreamDialogComponent, {
        //             size: 'xl',
        //             backdrop: 'static',
        //             centered: true,
        //             windowClass: 'confirmation-modal'
        //           });
        //           modalRef2.componentInstance.URL = response.signUrl;
        //           modalRef2.result.then((result: any) => {
        //             if (result) {
        //               this.letterDocument.fetchingTransectionDetailsWithgroupId({ groupId: response.groupId }).subscribe({
        //                 next: (response) => {
        //                   if (response.finalDocumentUrl != null && response.finalDocumentUrl != '') {
        //                     this.TableDatas[index].LetterGenerationFileName = response.finalDocumentUrl;
        //                   } else {
        //                     const modalRef3 = this.modalService.open(AlertWarningComponent, {
        //                       size: 'md',
        //                       backdrop: 'static',
        //                       centered: true,
        //                       windowClass: 'confirmation-modal'
        //                     });
        //                     modalRef3.componentInstance.Message = response.Error_Message;
        //                     modalRef3.result.then((result: any) => { });
        //                   }
        //                   this.isDisabled = false;
        //                 },
        //                 complete: () => { },
        //                 error: (error) => {
        //                   this.isDisabled = false;
        //                 },
        //               });
        //             }
        //           });
        //         }
        //         this.isDisabled = false;
        //       },
        //       complete: () => { },
        //       error: (error) => {
        //         this.isDisabled = false;
        //       },
        //     });
        //   };
        //   reader.readAsDataURL(blob); // Read the Blob as a data URL
        // }, error => {
        //   console.error('Error fetching the image:', error);
        // });
      }
    });
  }
}
